// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"g0-z"};